import { useState } from "react";
import { useDispatch } from "react-redux";
import { currentCompany } from "reducers/company/companySlice";
import axios from "utils/axiosConfig";
import { extractErrorMessage } from "hooks/useRecruitmentProcess";

export function useSubscriptionEditTags() {
    const dispatch = useDispatch();

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSuccess, setIsSuccess] = useState(false);

    const editTags = async ({ subscriptionId, tagIds }) => {
        setIsLoading(true);
        setError(null);
        setIsSuccess(false);
        setData(null);

        try {
            const response = await axios.post(
                `/api/subscriptions/${subscriptionId}/edit-tags`,
                { tagIds },
            );
            setData(response?.data);
            setIsSuccess(true);
            if (response?.data) dispatch(currentCompany(response.data));
            return { isSaved: true, errorMessage: null };
        } catch (err) {
            const fallbackMsg = "Failed to edit subscription tags.";
            const apiMsg =
                err?.response?.data?.message ||
                extractErrorMessage(err?.response?.data);
            const errorMessage = apiMsg || fallbackMsg;
            setError(errorMessage);
            return { isSaved: false, errorMessage };
        } finally {
            setIsLoading(false);
        }
    };

    return {
        editTags,
        isLoading,
        error,
        isSuccess,
        data,
    };
}
